import { Pipe, PipeTransform, SecurityContext } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({
  name: 'truncateText',
})
export class TruncateTextPipe implements PipeTransform {
  constructor() {}
  transform(text: string, count: number): any {
    if (text.length > count) {
      return text.slice(0, count) + ' ...';
    } else {
      return text;
    }
  }
}
